import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { hasRole } from '@/lib/roles';
import type { Role } from '@/api/types';

export function RoleRoute({ allow }: { allow: Role[] }) {
  const user = useAuthStore((s) => s.user);

  if (!hasRole(user, ...allow)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
